import React from "react";
import FooterSection from "../../components/sections/FooterSection";
import { useTranslation } from "react-i18next";

/**
 * Page about the history of the company
 * @param {*} props 
 * @returns 
 */
function AboutPage(props) {

    var { t } = useTranslation();

    return (
        <>
            {/* Intro Section */}
            <section className="uk-section uk-section-default   uk-animation-fade">
                <div className="uk-container uk-margin-large-top uk-margin-large-bottom">
                    <h1 className="uk-heading-medium uk-text-center uk-animation-slide-top">
                        {t("infopages.about.title")}
                    </h1>
                    <div className="uk-grid-large uk-flex-middle" data-uk-grid>
                        <div className="uk-width-1-3@m uk-text-center">
                            <a href="/staff/buba.jpg" data-uk-lightbox="animation: fade">
                                <img
                                    src="/staff/buba.jpg"
                                    alt="Founder Buba Jallow"
                                    className="uk-border-circle uk-box-shadow-medium"
                                    style={{ maxWidth: "200px", display: "block" }}
                                />
                            </a>
                        </div>
                        <div className="uk-width-2-3@m uk-animation-slide-left-medium">
                            <h2 className="uk-heading-line"><span>{t("infopages.about.intro-heading")}</span></h2>
                            <p className="uk-text-lead uk-margin-medium-top uk-text-dark">{t("infopages.about.intro-text")}</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Expansion Section */}
            <section className="uk-section uk-section-muted  ">
                <div className="uk-container uk-margin-large-top uk-margin-large-bottom">
                    <h2 className="uk-heading-line uk-text-center uk-text-light"><span>{t("infopages.about.expansion-heading")}</span></h2>
                    <div className="uk-child-width-1-1@m uk-grid-small uk-grid-match uk-animation-slide-bottom-medium" data-uk-grid>
                        <div>
                            <div className="uk-card uk-card-default uk-card-hover uk-card-body">
                                <p className="uk-text-lead uk-text-light">{t("infopages.about.expansion-text")}</p>
                                <span className="uk-icon-link uk-text-light" data-uk-icon="icon: world"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Mission & Vision Tiles Section */}
            <section className="uk-section uk-section-default  ">
                <div className="uk-container uk-margin-large-top uk-margin-large-bottom">
                    <div className="uk-grid-large uk-child-width-1-2@m" data-uk-grid>
                        {/* Mission Card */}
                        <div>
                            <div className="uk-card uk-card-jai uk-card-body uk-card-hover uk-animation-slide-left-medium">
                                <h2 className="uk-heading-line"><span>{t("infopages.about.mission-heading")}</span></h2>
                                <p className="uk-text">{t("infopages.about.mission-text")}</p>
                                <span className="uk-icon-link uk-text-light" data-uk-icon="icon: bolt"></span>
                            </div>
                        </div>
                        {/* Vision Card */}
                        <div>
                            <div className="uk-card uk-card-secondary uk-card-body uk-card-hover uk-animation-slide-right-medium">
                                <h2 className="uk-heading-line"><span>{t("infopages.about.vision-heading")}</span></h2>
                                <p className="uk-text-dark">{t("infopages.about.vision-text")}</p>
                                <span className="uk-icon-link uk-text-dark" data-uk-icon="icon: eye"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Values Section */}
            <section className="uk-section uk-section-muted">
                <div className="uk-container uk-margin-large-top uk-margin-large-bottom">
                    <h2 className="uk-heading-line uk-text-center uk-text-light">
                        <span>{t("infopages.about.values-heading")}</span>
                    </h2>
                    <div className="uk-card uk-card-default uk-card-hover uk-card-body uk-text-center uk-animation-fade">
                        <p className="uk-text-light">{t("infopages.about.values-text")}</p>
                        <span className="uk-icon-link uk-text-light" data-uk-icon="icon: star"></span>
                    </div>
                </div>
            </section>


            {/* Note Section */}
            <section className="uk-section uk-section-default  ">
                <div className="uk-container uk-margin-large-top uk-margin-large-bottom">
                    <h2 className="uk-heading-line uk-text-center"><span>{t("infopages.about.note-heading")}</span></h2>
                    <p className="uk-text-lead uk-text-center uk-animation-slide-bottom-medium uk-text-dark">
                        {t("infopages.about.note-text")}
                    </p>
                </div>
            </section>

            <FooterSection />
        </>

    );
}

export default AboutPage;